import {
  LARGEST_THUMBNAIL_FONT_SIZE,
  THUMBNAIL_WIDTH_FONT_SIZE_MAPPING,
} from "./constants";

export const getFontSize = (thumbnailWidth: number): string =>
  THUMBNAIL_WIDTH_FONT_SIZE_MAPPING.find(
    ([width]) => thumbnailWidth <= width,
  )?.[1] ?? LARGEST_THUMBNAIL_FONT_SIZE;
